// AllSections.jsx

import React from 'react';
import Homepage from './Homepage';
import AirdropLoot from './AirdropLoot';
import ConnectWallet from './ConnectWallet';
import Roadmap from './Roadmap';       // ✅ Moved before Features
import Features from './Features';
import './AllSections.css';

const AllSections = () => {
  return (
    <div className="all-sections">
      <section id="homepage">
        <Homepage />
      </section>

      <section id="airdrop">
        <AirdropLoot />
      </section>

      <section id="connect-wallet">
        <ConnectWallet />
      </section>

      <section id="roadmap">   {/* ✅ Corrected Order */}
        <Roadmap />
      </section>

      <section id="features">  {/* ✅ Moved to Bottom */}
        <Features />
      </section>
    </div>
  );
};

export default AllSections;
